import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import { Label, Alert } from "components/bootstrap";
import { Timestamp } from "components/common";
import { formatReadableNumber } from "util/NumberFormatting";
import ProviderName from "ai-management/components/ProviderName";
import { formatDuration } from "aiagent/utils";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
import { TRIGGER_LABELS } from "./Constants";
import RunStateLabel from "./RunStateLabel";
import StatusBadge from "./StatusBadge";
export const REPORT_SECTION_ID = "report";
const StyledAlert = styled(Alert)`
  background-color: transparent;
  border: none;
`;
const SummaryValue = ({ entry }) => {
  var _a;
  const { t } = useTranslation("enterprise_ai");
  if (entry.state === "failed" && entry.status === null) {
    return /* @__PURE__ */ React.createElement(
      StyledAlert,
      {
        noIcon: true,
        compact: true,
        title: t("column_renderers.error_during_run", { reason: entry.error_reason }),
        bsStyle: "danger"
      },
      /* @__PURE__ */ React.createElement("i", null, entry.error)
    );
  }
  return (_a = entry.summary) != null ? _a : "";
};
const customColumnRenderers = {
  attributes: {
    model: {
      staticWidth: 220
    },
    ran_at: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(Timestamp, { dateTime: entry.ran_at })
    },
    type: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(Label, { title: i18n.t("run_header.workflow_type", { ns: "enterprise_ai", type: entry.type }) }, entry.type),
      // Wide enough for the longest registered workflow type
      // (`event-definition-tuning-advisor`, 31 chars in the label).
      staticWidth: 230
    },
    provider: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(ProviderName, { providerId: entry.provider }),
      staticWidth: 130
    },
    state: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(RunStateLabel, { entry }),
      staticWidth: 110
    },
    status: {
      renderCell: (_, entry) => entry.status ? /* @__PURE__ */ React.createElement(StatusBadge, { status: entry.status }) : null,
      staticWidth: 100
    },
    triggered_by: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(
        Label,
        {
          title: i18n.t("run_header.triggered_by", {
            ns: "enterprise_ai",
            trigger: i18n.t(TRIGGER_LABELS[entry.triggered_by], { ns: "enterprise_ai" })
          })
        },
        i18n.t(TRIGGER_LABELS[entry.triggered_by], { ns: "enterprise_ai" })
      ),
      staticWidth: "matchHeader"
    },
    ran_by: {
      renderCell: (_, entry) => entry.ran_by,
      staticWidth: COLUMN_WIDTH.user
    },
    duration_ms: {
      renderCell: (_, entry) => formatDuration(entry.duration_ms),
      textAlign: "left",
      staticWidth: 130
    },
    token_usage: {
      renderCell: (_, entry) => entry.token_usage == null ? "" : formatReadableNumber(entry.token_usage.total_tokens),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    summary: {
      renderCell: (_, entry) => /* @__PURE__ */ React.createElement(SummaryValue, { entry })
    }
  }
};
export default customColumnRenderers;
